var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"entry-short",style:({ backgroundImage: 'url(' + _vm.cmsPageHeaderImage + ')' })},[_c('div',{staticClass:"context"},[_c('h1',{staticClass:"error-title"},[_vm._v("404")]),_c('h2',{domProps:{"innerHTML":_vm._s(_vm.errorSentence)}}),_c('img',{staticClass:"error-image",attrs:{"src":require("@/assets/404.png")}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }